import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useLocaisOutletContext } from 'pages/Locais.context'
import { useParams } from 'react-router-dom'
import { local } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirLocal() {
    const { id } = useParams()
    const { data } = useLocaisOutletContext()
    const l = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = local.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!l) return null

    const handleSubmit = () =>
        mutateAsync(l.id, {
            onSuccess: () => {
                toast.success('Local excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'Locais']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={<>Realmente deseja excluir o local {l.nomeLocal}?</>}
        />
    )
}
